import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKKP from '../../../assets/images/logo.png';
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import imgCheckBox from "../../../assets/images/icons/checkbox_blank_outline_icon.png"
import imgCheckBoxIcon from "../../../assets/images/icons/checkbox_icon.png"

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })
Font.register({ family: 'Arial MT Black', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        padding: 20,
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 250,
    },
    headingEn: {
        fontSize: 8,
        textAlign: "center",
    },
    section: {
        marginBottom: 10,
    },
    table: {
        display: 'flex',
        width: '100%',
        border: '1 solid black',
    },
    tableCon1: {
        borderBottom: '1 solid black',
        borderRight: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableCon2: {
        borderBottom: '1 solid black',
        borderRight: '1 solid black',
        display: 'table',
        width: '40%',
    },
    row: {
        flexDirection: 'row',
    },
    cell: {
        border: '1 solid black',
        flexGrow: 1,
        fontSize: 8,
    },
    headerCell: {
        fontWeight: 'bold',
    },
    leftColumn: {
        width: '45%',
    },
    rightColumn: {
        width: '15%',
    },
    leftNo: {
        width: '1.7%%',
    },
    rightIsi: {
        width: '59.5%',
    },
    rightIsi2: {
        width: '58.3%',
    },
    rightIsi3: {
        width: '54.5%',
    },
    verticalText: {
        writingMode: 'vertical-rl',
        transform: 'rotate(270deg)',
        textAlign: 'center',
        padding: 4,
        fontSize: 10,
    },
    textEnBold: {
        fontFamily: "Arial MT Black",
        fontSize: 10,
        paddingLeft: 3
    },
    textEnVert: {
        fontFamily: "Arial MT Black",
        fontSize: 9,
        paddingLeft: 3
    },
    textEn: {
        fontSize: 10,
        paddingLeft: 3
    },
    textEnIsi: {
        fontSize: 9,
        paddingLeft: 3
    },
    italicText: {
        fontFamily: "Roboto-Italic",
        fontSize: 10,
    },
    squareStyle: {
        width: '10px',
        height: '10px',
        border: 1,
        borderColor: '#000000',
    },
    checkicon: {
        width: 12,
        height: 12
    }
});


const DraftNZ = ({ dataDisposisi, datappm, qrImage }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmKemasan, setPpmKemasan] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const results = await Promise.allSettled([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getNegaraById(datappm.negaraPartner),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
            ])

            const [
                resHc,
                resUpt,
                resNeg,
                resPelMuat,
                resDetil,
                resKemasanAll,
                resKontainer,
                resMutu
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            // Update state (batched oleh React)
            setDataHc(getData(resHc));
            setUpt(getData(resUpt, {}));
            setNegaraTujuan(getData(resNeg, {}))
            setPelMuat(getData(resPelMuat, {}));
            setPpmDetil(getData(resDetil));
            setPpmKemasan(getData(resKemasanAll));
            setPpmKontainer(getData(resKontainer));
            setPpmMutu(getData(resMutu, {}));
            
        } catch (error) {
            
        }
    }, [datappm, transaksiService, dataDisposisi, masterService, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap={false}>
                <View>
                    <Image style={styles.headingImg} src={imgKKP} />
                </View>
                <View>
                    <Text style={styles.headingEn}>MINISTRY OF MARINE AFFAIRS AND FISHERIES</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>HEALTH CERTIFICATE FOR EXPORT OF NON-SALMONID AQUATIC ANIMAL PRODUCTS TO NEW ZEALAND</Text>
                </View>
                {/* Header */}
                <View style={[styles.row, styles.section, { paddingTop: '5px' }]}>
                    <View style={[styles.cell, { width: '30%', borderRight: 0, backgroundColor: '#D3D3D3', paddingVertical: '5px' }]}>
                        <Text style={styles.textEn}>Competent Authority</Text>
                    </View>
                    <View style={[styles.cell, { width: '55%', borderRight: 0, paddingVertical: '5px' }]}>
                        <Text style={styles.textEnBold}>Marine And Fisheries Quality Assurance Agency</Text>
                        <Text style={styles.textEnBold}>Ministry of Marine Affairs and Fisheries Indonesia</Text>
                    </View>
                    <View style={[styles.cell, styles.rightColumn]}>
                        <View style={[styles.row, { borderBottom: 1, backgroundColor: '#D3D3D3', paddingVertical: '5px' }]}>
                            <Text style={styles.textEn}>COUNTRY</Text>
                        </View>
                        <View style={[styles.row, { paddingVertical: '5px' }]}>
                            <Text style={styles.textEn}>INDONESIA</Text>
                        </View>
                    </View>
                </View>

                {/* Part 1: Details of Dispatched Consignment */}
                <View style={[styles.table, { borderBottom: 0 }]}>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftColumn, { border: 0, borderLeft: 1, paddingVertical: '8px', backgroundColor: '#D3D3D3' }]}>
                            <Text style={styles.textEn}>1. Consignor</Text>
                        </View>
                        <View style={[styles.cell, styles.rightColumn, { border: 0, borderLeft: 1, paddingVertical: '8px', backgroundColor: '#D3D3D3' }]}>
                            <Text style={styles.textEn}>2. Certificate Reference Number</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}>Consignment</Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '15%', borderRight: 0 }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px', backgroundColor: '#D3D3D3' }]}>
                                <Text style={styles.textEn}>Name</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 1, paddingVertical: '10px', backgroundColor: '#D3D3D3' }]}>
                                <Text style={styles.textEn}>Address</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '18%' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 1, paddingVertical: '10px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { width: '15%', borderBottom: 1, borderRight: 0, paddingVertical: '5px' }]}>
                            <Text style={styles.textEn}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '71.5%', border: 0, borderLeft: 1, paddingVertical: '5px', backgroundColor: '#D3D3D3' }]}>
                            <Text style={styles.textEn}>3. Consignee (importer)</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}>Dispatched</Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '15%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>Name</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '10px' }]}>
                                <Text style={styles.textEn}>Address</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '44.5%' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '10px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '5%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>4. Country of Origin</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '54.5%' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>INDONESIA</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}>Details of</Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '5%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>5. Country of Destination</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '54.5%' }]}>
                            <View style={[styles.cell, { borderRight: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>{negaraTujuan !== null ? negaraTujuan.uraianNegara : '-'}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '7px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}>Part 1:</Text>
                        </View>
                        <View style={[styles.cell, { width: '71.5%', border: 0, borderLeft: 1, paddingVertical: '5px', backgroundColor: '#D3D3D3' }]}>
                            <Text style={styles.textEn}>6. processor</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '15%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>Name</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '10px' }]}>
                                <Text style={styles.textEn}>Address</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>Establishment Number</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '44.5%' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '10px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? dataHc.alUpi : ''}</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '5%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>7. Port Dispatched from</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '13%' }]}>
                            <View style={[styles.cell, { borderRight: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEnIsi}>{pelMuat !== null ? pelMuat.uraianPelabuhan : '-'}</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '5%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>8. Date of Departed</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '13%' }]}>
                            <View style={[styles.cell, { borderRight: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglBerangkat) : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '5%', backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>9. Means of transport</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, borderLeft: 1, width: '13%' }]}>
                            <View style={[styles.row, { borderRight: 0, paddingVertical: '5px' }]}>
                                {/* <View style={styles.squareStyle}></View> */}
                                {
                                    datappm !== null && datappm.moda === '3' ?
                                    <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                    <Image src={imgCheckBox} style={styles.checkicon} />
                                }
                                <Text style={styles.textEnIsi}>Aeroplane</Text>
                            </View>
                            <View style={[styles.row, { borderRight: 0, paddingVertical: '5px' }]}>
                                {/* <View style={styles.squareStyle}></View> */}
                                {
                                    datappm !== null && datappm.moda === '1' ?
                                    <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                    <Image src={imgCheckBox} style={styles.checkicon} />
                                }
                                <Text style={styles.textEnIsi}>Ship</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '5%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>10. Temperature of commodities for transport</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '13%' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEnIsi}>{ppmMutu !== null ? ppmMutu.mutuTemp : ''} DEGREE CELCIUS</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '9.5%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>11. Product name</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '9%', backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>12. Name of aquatic animal species in the product if required</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '2%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>13. Number of packages</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '2%', backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>14. Net weight (Kg)</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '2%', backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>15. HS Code</Text>
                            </View>
                        </View>
                    </View>
                    {
                        ppmDetil.map((detil, index) => {
                            return (
                                <>
                                    <View style={[styles.row, { border: 0 }]}>
                                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                                        </View>
                                        <View style={[styles.cell, { border: 0, width: '9.5%', borderRight: 0 }]}>
                                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                                <Text style={styles.textEnIsi}>{detil.namaLokal}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.cell, { border: 0, width: '9%' }]}>
                                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                                <Text style={styles.textEnIsi}>{detil.namaLatin}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.cell, { border: 0, width: '2%', borderRight: 0 }]}>
                                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                                {
                                                    ppmKemasan.map((kms, idxKms) => {
                                                        return (
                                                            <>
                                                                <Text key={idxKms} style={[styles.textEnIsi]}>{kms.jumlah}</Text>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </View>
                                        </View>
                                        <View style={[styles.cell, { border: 0, width: '2%' }]}>
                                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                                <Text style={styles.textEnIsi}>{detil.jumlah}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.cell, { border: 0, width: '2%' }]}>
                                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                                <Text style={styles.textEnIsi}>{detil.kodeHs}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </>
                            )
                        })
                    }
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, borderBottom: 1, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '11%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>16. Container number</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '11%' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEnIsi}>
                                    {
                                        ppmKontainer !== undefined && ppmKontainer !== null &&
                                        ppmKontainer.map((kont, index) => {
                                            return (
                                                <>
                                                    {kont.nomor}{index < ppmKontainer.length - 1 ? ', ' : ''}
                                                </>
                                            )
                                        })
                                    }
                                </Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '7%', borderRight: 0, backgroundColor: '#D3D3D3' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEn}>17. Seal Number</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '7s%' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderTop: 0, paddingVertical: '5px' }]}>
                                <Text style={styles.textEnIsi}>
                                    {
                                        ppmKontainer !== undefined && ppmKontainer !== null &&
                                        ppmKontainer.map((kont, index) => {
                                            return (
                                                <>
                                                    {kont.nomorSegel}{index < ppmKontainer.length - 1 ? ', ' : ''}
                                                </>
                                            )
                                        })
                                    }
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.row, styles.section, { paddingTop: 5 }]}>
                    <View style={[styles.cell, styles.leftColumn, { borderWidth: 0 }]}>
                        <Text style={[styles.textEn, { textAlign: 'right' }]}>Page 1 of 4</Text>
                    </View>
                </View>
            </Page>
            <Page size="A4" style={styles.page} wrap={false}>
                {/* Header */}
                <View style={[styles.row, styles.section, { paddingTop: 5 }]}>
                    <View style={[styles.cell, { width: '20%', borderRight: 0, backgroundColor: '#D3D3D3', paddingVertical: '5px' }]}>
                        <Text style={styles.textEn}>Competent Authority</Text>
                    </View>
                    <View style={[styles.cell, { width: '40%', borderRight: 0, paddingVertical: '5px' }]}>
                        <Text style={styles.textEnBold}>Marine And Fisheries Quality Assurance Agency</Text>
                        <Text style={styles.textEnBold}>Ministry of Marine Affairs and Fisheries Indonesia</Text>
                    </View>
                    <View style={[styles.cell, { width: '10%', borderRight: 0, backgroundColor: '#D3D3D3', paddingVertical: '5px' }]}>
                        <Text style={styles.textEn}>Certificate Reference Number</Text>
                    </View>
                    <View style={[styles.cell, { width: '10%', paddingVertical: '5px' }]}>
                        <Text style={styles.textEn}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                    </View>
                </View>
                {/* Part 2: Health Information */}
                <View style={[styles.table, { borderBottom: 0 }]}>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '8px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '72.5%', border: 0, borderLeft: 1, paddingVertical: '8px' }]}>
                            <Text style={styles.textEn}>I, the undersigned Certifying Official, certify that the products described below satisfy the following requirements:</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '8px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}>mation</Text>
                        </View>
                        <View style={[styles.cell, { width: '72.5%', border: 0, borderLeft: 1, paddingVertical: '8px' }]}>
                            <Text style={styles.textEnBold}>General Requirements</Text>
                        </View>
                    </View>
                    <View style={[styles.row,]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { paddingLeft: 3 }]}>Infor</Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(1)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={[styles.textEn, { paddingLeft: 0 }]}>The product was processed at premises that follow Good Manufacturing Practice (GMP) and Hazard Analysis and Critical Control Point (HACCP) programmes. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(2)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={[styles.textEn, { paddingLeft: 0 }]}>The product was processed at premises that are approved for export of aquatic animal products.</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '8px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}>Health</Text>
                        </View>
                        <View style={[styles.cell, { width: '72.5%', border: 0, borderLeft: 1, paddingVertical: '8px' }]}>
                            <Text style={styles.textEnBold}>Specific Requirements</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '6px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}>Part 2:</Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>(3)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>Non-salmonid fish products commercially packaged for direct retail sale (delete where not applicable):</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from a fish species that does not belong to the family Salmonidae. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The net content of each package is not more than 1.0 kg or 1.0 litre (delete where not applicable); or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(c)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The net content of each package is more than 1.0 kg or 1.0 litre (delete where not applicable) [Note: The importer must have an import permit for this option], or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(e)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The consignment includes packages with net content of not more than 1.0 kg or 1.0 litre and more than 1.0 kg or 1.0 litre (delete where not applicable) [Note: The importer must have an import permit for this option.]  </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(4)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>Heat-treated non-salmonid fish products (delete where not applicable): </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from a fish species that does not belong to the family Salmonidae. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product has been heat treated to one of the following time/temperature parameters</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '0%', paddingLeft: 35, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(i)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi3, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>Heat treated to a minimum core temperature of 85°C for a period of not less than 15 minutes (delete where not applicable); or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '0%', paddingLeft: 35, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(ii)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi3, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>Heat treated to a minimum core temperature of 90°C for a period of not less than 10 minutes (delete where not applicable). </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(5)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>Dried non-salmonid fish products (delete where not applicable): </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from a fish species that does not belong to the family Salmonidae. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is eviscerated fish. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, borderBottom: 1, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderBottom: 1, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(c)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, borderBottom: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product was mechanically dried at a minimum core temperature of 100°C for a period of not less than 30 minutes.  </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.row, styles.section, { paddingTop: 5 }]}>
                    <View style={[styles.cell, styles.leftColumn, { borderWidth: 0 }]}>
                        <Text style={[styles.textEn, { textAlign: 'right' }]}>Page 2 of 4</Text>
                    </View>
                </View>
            </Page>
            <Page size="A4" style={styles.page} wrap={false}>
                <View style={[styles.table, { borderBottom: 0 }]}>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '6px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>(7)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>Low-risk, non-salmonid fish products (delete where not applicable): </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from _________________ </Text>
                            <Text style={styles.italicText}>(write the full scientific name of the fish species), which is listed in Schedule 4 of New Zealand's Import Health Standard: Aquatic Animal Products. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from _________________ </Text>
                            <Text style={styles.italicText}>(write the full scientific name of the fish species), a fish species listed in Schedule 5 of New Zealand's Import Health Standard: Aquatic Animal Products, and </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '0%', paddingLeft: 35, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(i)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi3, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>Has been frozen to a minimum core temperature of -18°C for a period of not less than 168 hours prior to transport; or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '0%', paddingLeft: 35, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(ii)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi3, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>Will be frozen to a minimum core temperature of -18°C for a period of not less than 168 hours during transport (bill of lading or data logs of temperature records of the refrigerated container must be submitted to MPI for biosecurity clearance). </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(c)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from _________________ </Text>
                            <Text style={styles.italicText}>(write the full scientific name of the fish species), a fish species listed in Schedule 6 of New Zealand's Import Health Standard: Aquatic Animal Products; and </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '0%', paddingLeft: 35, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(i)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi3, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>Has been frozen to a minimum core temperature of -18°C for a period of not less than four months prior to transport, and/or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '0%', paddingLeft: 35, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(ii)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi3, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>Will be frozen to a minimum core temperature of -18°C for a period of not less than four months during transport </Text>
                            <Text style={styles.italicText}>(bill of lading or data logs of temperature records of the refrigerated container must be submitted to MPI for biosecurity clearance). </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '6px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>(8)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>Crustacean products commercially packaged for direct retail sale (delete where not applicable): </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The net content of each package is not more than 1.0 kg or 1.0 litre (delete where not applicable); or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The net content of each package is more than 1.0 kg or 1.0 litre (delete where not applicable) </Text>
                            <Text style={styles.italicText}>[Note: The importer must have an import permit for this option.]; or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(c)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The consignment includes packages with net content of not more than 1.0 kg or 1.0 litre and more than 1.0 kg or 1.0 litre (delete where not applicable) </Text>
                            <Text style={styles.italicText}>[Note: The importer must have an import permit for this option.] </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '6px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>(9)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>Heat-treated crustacean products (delete where not applicable): </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from _________________</Text>
                            <Text style={styles.italicText}>(write the full scientific name of the crustacean species), which is listed in Schedule 8 of New Zealand's Import Health Standard: Aquatic Animal Products, and </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '0%', paddingLeft: 35, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(i)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi3, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>Was heat treated to a minimum core temperature of 100°C for period of not less than one minute; or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '0%', paddingLeft: 35, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(ii)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi3, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>Was heat treated to a minimum core temperature of 90°C for a period of not less than 10 minutes; or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from _________________ </Text>
                            <Text style={styles.italicText}>(write the full scientific name of the crustacean species), which is NOT listed in Schedule 8 of New Zealand's Import Health Standard: Aquatic Animal Products and was heat-treated until the protein in the crustacean meat is coagulated. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '6px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>(10)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>Frozen crustacean products (delete where not applicable): </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from _________________  </Text>
                            <Text style={styles.italicText}>(write the full scientific name of the crustacean species), which is listed in Schedule 8 of New Zealand's Import Health Standard: Aquatic Animal Products and has been frozen to a minimum core temperature of -20°C for a period of not less than 72 hours; or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, borderBottom: 1, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderBottom: 1, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, borderBottom: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from _________________ </Text>
                            <Text style={styles.italicText}>(write the full scientific name of the crustacean species), which is NOT listed in Schedule 8 of New Zealand's Import Health Standard: Aquatic Animal Products and has been frozen to a minimum core temperature of -18°C for a period of not less than 12 hours. </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.row, styles.section, { paddingTop: 5 }]}>
                    <View style={[styles.cell, styles.leftColumn, { borderWidth: 0 }]}>
                        <Text style={[styles.textEn, { textAlign: 'right' }]}>Page 3 of 4</Text>
                    </View>
                </View>
            </Page>
            <Page size="A4" style={styles.page} wrap={false}>
                <View style={[styles.table, { borderBottom: 0 }]}>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '6px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>(11)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>Haliotis spp. (abalone) products (delete where not applicable): </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is meat derived only from Haliotis spp. (abalone). </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The shells of the Haliotis spp. (abalone) have been removed completely</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(c)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The Haliotis spp. (abalone) meat has been heat-treated to a minimum core temperature of 55°C for a period of not less than 10 minutes. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '6px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>(12)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>Mollusc products other than Haliotis spp. (abalone) (delete where not applicable): </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived from a mollusc species that is not a Haliotis spp. (abalone). </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The mollusc meat is cooked, dried, or frozen. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(c)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The mollusc shells have been removed completely and not included in the consignment (delete where not applicable); or </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '0%', paddingLeft: 35, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(i)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi3, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The shells were removed then cleaned and sanitised, and the mollusc meat put back on to the cleaned and sanitised shells (delete where not applicable). </Text>
                            <Text style={styles.italicText}>[Note: The importer must have an import permit for this option.] </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '6px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText, { textAlign: 'right' }]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { border: 0, borderLeft: 1, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>(13)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi, { border: 0, paddingVertical: '6px' }]}>
                            <Text style={styles.textEnBold}>Aquatic animal meal / aquatic animal oil (delete where not applicable): </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(a)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product is derived only from aquatic animal species. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '4px' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, styles.leftNo, { paddingLeft: 15, border: 0, borderLeft: 1, paddingVertical: '4px' }]}>
                            <Text style={styles.textEnBold}>(b)</Text>
                        </View>
                        <View style={[styles.cell, styles.rightIsi2, { border: 0, paddingVertical: '4px' }]}>
                            <Text style={styles.textEn}>The product was heat treated at a minimum core temperature of 80°C for a period of no less than 20 minutes. </Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3', paddingVertical: '12px' }]}>
                            <Text style={[styles.textEnBold, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { width: '72.5%', border: 0, borderLeft: 1, paddingVertical: '12px' }]}>
                            <Text style={styles.italicText}>Note: Certifying official signature and stamp to be applied to all pages</Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '45%', borderRight: 0 }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, paddingVertical: '10px', backgroundColor: '#D3D3D3' }]}>
                                <Text style={styles.textEnBold}>Certifying Official: </Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { width: '15%', borderBottomWidth: 0, borderRight: 0, paddingVertical: '10px' }]}>
                            <Text style={styles.textEn}></Text>
                        </View>
                    </View>
                    <View style={[styles.row]}>
                        <View style={[styles.cell, { width: '5%', border: 0, backgroundColor: '#D3D3D3' }]}>
                            <Text style={[styles.textEnVert, styles.verticalText]}></Text>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '15%', borderRight: 0 }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '30px', backgroundColor: '#D3D3D3' }]}>
                                <Text style={styles.textEn}>Signature </Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '30px', backgroundColor: '#D3D3D3' }]}>
                                <Text style={styles.textEn}>Name </Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '30px', backgroundColor: '#D3D3D3' }]}>
                                <Text style={styles.textEn}>Designation  </Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '30px', backgroundColor: '#D3D3D3' }]}>
                                <Text style={styles.textEn}>Address </Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '30px', backgroundColor: '#D3D3D3' }]}>
                                <Text style={styles.textEn}>Email </Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 1, height: '30px', backgroundColor: '#D3D3D3' }]}>
                                <Text style={styles.textEn}>Date </Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { border: 0, width: '18%' }]}>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '20px' }]}>
                                <Text style={styles.textEnIsi}></Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '20px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '20px' }]}>
                                <Text style={styles.textEnIsi}>OFFICIAL INSPECTOR</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '20px' }]}>
                                <Text style={styles.textEnIsi}>{upt !== null ? upt.alamatUnit : '-'}</Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 0, height: '20px' }]}>
                                <Text style={styles.textEnIsi}></Text>
                            </View>
                            <View style={[styles.cell, { borderRight: 0, borderBottom: 1, height: '20px' }]}>
                                <Text style={styles.textEnIsi}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.cell, { width: '15%', borderBottom: 1, borderTop: 0, borderRight: 0, paddingVertical: '10px' }]}>
                            <View style={[styles.cell, { border: 0, paddingVertical: '10px' }]}>
                                <Text style={styles.textEnIsi}></Text>
                            </View>
                            <View style={[styles.cell, { border: 0, paddingVertical: '10px' }]}>
                                <Text style={styles.textEnIsi}></Text>
                            </View>
                            <View style={[styles.cell, { border: 0, paddingVertical: '10px' }]}>
                                <Text style={styles.textEnIsi}></Text>
                            </View>
                            <View style={[styles.cell, { border: 0, paddingVertical: '10px' }]}>
                                <Text style={styles.textEnIsi}></Text>
                            </View>
                            <View style={[styles.cell, { border: 0, paddingVertical: '10px' }]}>
                                <Text style={styles.textEnIsi}></Text>
                            </View>
                            <View style={[styles.cell, { border: 0, paddingVertical: '10px' }]}>
                                <Text style={[styles.italicText, { fontSize: 6, textAlign: 'center' }]}>certifying official signature, official stamp, and date</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.row, styles.section, { paddingTop: 5 }]}>
                    <View style={[styles.cell, styles.leftColumn, { borderWidth: 0 }]}>
                        <Text style={[styles.textEn, { textAlign: 'right' }]}>Page 4 of 4</Text>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default DraftNZ